import { combineReducers } from 'redux';
import list from './list/reducer';
import settings from './settings/reducer';

export default combineReducers({
	list,
	settings,
});
